import type { CostUnit } from "@loumy/contracts";

// §3.6 / D34 — Metriken werden BEIM BUILD aus den eingefrorenen `params` (Literale)
// abgeleitet; Pricing & Persistenz nutzen denselben Plan. Die Pricing-Engine kennt
// keine Capability-Interna: sie liest die Metrik-Werte über eine dokumentierte
// MVP-Konvention aus den numerischen params. buildPipeline (M4) friert genau diese
// Schlüssel als Number-Literale ein (z.B. `durationS`, `count`, `megapixel`).
//
// Hier liegen NUR die reinen, foot-gun-freien Bausteine (Konstanten + ein strikter
// Lese-Helfer). Die fail-closed-Auswertung (werfen bei fehlend/negativ/Overflow)
// lebt vollständig in price.ts — es gibt KEINE öffentlichen lenienten Helfer, die
// eine Unterbepreisung still durchgehen lassen könnten (Codex-P1).

/** unit → Kandidaten-Param-Schlüssel (erster numerischer Treffer gewinnt). `flat` = konstante 1. */
export const UNIT_PARAM_KEYS: Record<CostUnit, readonly string[]> = {
  flat: [],
  second: ["durationS", "seconds", "duration"],
  frame: ["frameCount", "targetFrameCount", "frames"],
  image: ["count", "images"],
  megapixel: ["megapixel", "megapixels", "mp"],
};

/** Fan-out-Kardinalität (D42-„menge"): erster numerischer Treffer; buildPipeline friert sie ein. */
export const FANOUT_COUNT_KEYS: readonly string[] = ["count", "menge", "n"];

/** Erster endlich-numerischer Param-Wert aus `keys`, sonst `undefined`. Liest nur eigene Keys. */
export function firstNumericParam(params: Record<string, unknown>, keys: readonly string[]): number | undefined {
  for (const k of keys) {
    if (!Object.prototype.hasOwnProperty.call(params, k)) continue;
    const v = params[k];
    if (typeof v === "number" && Number.isFinite(v)) return v;
  }
  return undefined;
}
